// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__xMOcv","upload":"Small_upload__3Wyut","imageWrap":"Small_imageWrap__1WjFo","removeBtn":"Small_removeBtn__1VT6M"};